import axios, { AxiosRequestConfig } from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { REST_API_URL_V2 } from 'stores/AppStore';
import { isExpired, decodeToken } from 'react-jwt';

const RefreshToken = async (config: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
  const accessToken = localStorage.getItem('accessToken');
  const refreshToken = localStorage.getItem('refreshToken');

  if (accessToken && refreshToken) {
    const expired = isExpired(accessToken);

    if (expired) {
      // 만료된 토큰인 경우, 기존 토큰 제거 후 갱신 요청
      // localStorage.removeItem('accessToken');
      // localStorage.removeItem('refreshToken');
      if (config.headers) {
        delete config.headers.Authorization;
      }
      try {
        const response = await axios({
          method: 'post',
          url: `${REST_API_URL_V2}v1/auth/refresh-token`,
          data: {
            token: String(refreshToken),
          },
        });
        // 갱신 성공 시 새 토큰 저장 및 헤더 업데이트
        localStorage.setItem('accessToken', response.data.accessToken);
        localStorage.setItem('refreshToken', response.data.refreshToken);
        if (config.headers) {
          config.headers.Authorization = `Bearer ${response.data.accessToken}`;
        }
      } catch (error) {
        console.error('토큰 갱신 실패:', error);
        // 필요 시 추가 에러 처리(예: 로그아웃)
      }
      return config;
    } else if (config.headers) {
      // 유효한 토큰인 경우 헤더에 추가
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  } else {
    if (config.headers && accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  }
};

const refreshErrorHandle = (err: any) => {
  localStorage.removeItem('refreshToken');
};

export { RefreshToken, refreshErrorHandle };
